export enum LessonStatus {
  SCHEDULED = 'scheduled',
  STARTED = 'started',
  CANCELED = 'canceled',
  FINISHED = 'finished'
}
